import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './FilingsPage.css';
import { formatFormUrl } from '../utils/urlHelpers';
import FormCard from '../components/FormCard';

const FilingsPage = () => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Explicitly scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Track page view with GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_title: 'Filings - Tax & Business Filings',
      page_location: window.location.href,
      page_path: window.location.pathname
    });
    
    const fetchForms = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/forms/`);
        setForms(response.data);
      } catch (err) {
        setError('Failed to load forms');
        console.error('Error fetching forms:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchForms();
  }, []);

  // Function to get form icon based on form name
  const getFormIcon = (formName) => {
    const formType = formName.toLowerCase();
    
    if (formType.includes('irs form')) return 'irs-form';
    if (formType.includes('tax')) return 'tax';
    if (formType.includes('dissolution')) return 'dissolution';
    if (formType.includes('incorporation') || formType.includes('organization')) return 'incorporation';
    if (formType.includes('certificate') || formType.includes('copies')) return 'certificate';
    if (formType.includes('agent')) return 'agent';
    if (formType.includes('fincen') || formType.includes('fbar')) return 'fincen';
    if (formType.includes('valuation') || formType.includes('409a')) return 'valuation';
    if (formType.includes('annual report')) return 'annual-report';
    
    return 'default'; // Default icon
  };

  if (loading) {
    return (
      <div className="filings-page-container">
        <div className="loading">Loading available filings...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="filings-page-container">
        <div className="error-message">
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="filings-page-container">
      <div className="filings-header">
        <h1>Filings made easy</h1>
        <p>Our services include filings of the most relevant US corporate and Federal filings</p>
      </div>

      <div className="filings-page-grid">
        {forms.map((form) => (
          <FormCard 
            key={form.id}
            formName={form.form_name}
            iconType={getFormIcon(form.form_name)}
            url={formatFormUrl(form.form_name)}
          />
        ))}
      </div>
    </div>
  );
};

export default FilingsPage; 